import { Component, computed, inject, input } from '@angular/core';
import { Shoutout } from 'src/app/models/shoutout.model';
import { ShoutoutStoreService } from 'src/app/services/stores/shoutout.store.service';

@Component({
  selector: 'app-shoutouts-actions',
  templateUrl: './shoutouts-actions.component.html',
  styleUrl: './shoutouts-actions.component.scss',
  standalone: false,
  providers: [ShoutoutStoreService],
})
export class ShoutoutsActionsComponent {
  private _shoutoutStoreService = inject(ShoutoutStoreService);
  protected canReject = computed(
    () =>
      this.shoutout().paid &&
      !this.shoutout().moderated &&
      !this.shoutout().approved &&
      !this.shoutout().announced,
  );
  protected canRestore = computed(
    () =>
      (this.shoutout().paid &&
        this.shoutout().moderated &&
        !this.shoutout().approved &&
        !this.shoutout().announced) ||
      (this.shoutout().paid &&
        this.shoutout().moderated &&
        this.shoutout().approved &&
        this.shoutout().announced),
  );
  shoutout = input.required<Shoutout>();

  reject() {
    this._shoutoutStoreService.update({
      ...this.shoutout(),
      ...{
        moderated: true,
        approved: false,
        announced: false,
      },
    });
  }

  restore() {
    this._shoutoutStoreService.update({
      ...this.shoutout(),
      ...{
        moderated: false,
        approved: false,
        announced: false,
      },
    });
  }
}
